import { Dialog } from "components/dialog";
import { useNewAgent } from "../../../contexts/NewAgentContext";
import { useState } from "react";
import { FileSystemItem } from "types";
import { formatFileSize, getFileIcon } from "utils";
import { FaFolder } from "react-icons/fa";
import { X } from "lucide-react";
import { LibraryDialogContent } from "components/file-system/LibraryDialogContent";
import { useTranslation } from "hooks/useTranslation";
import { Library } from "constants/library";

const KnowledgeBase = () => {
  const { formData, setFormData } = useNewAgent();
  const [isLibraryOpen, setIsLibraryOpen] = useState(false);
  const { t } = useTranslation();
  const handleSelect = (selectedFileIds: FileSystemItem[]) => {
    setFormData((prev) => ({
      ...prev,
      knowledgeBase: selectedFileIds,
    }));
  };
  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <div className="flex flex-col gap-4">
        <Dialog
          trigger={
            <button
              type="button"
              onClick={() => setIsLibraryOpen(true)}
              className="h-[40px] rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 transition dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            >
              {t("agents.newAgent.selectFromLibrary")}
            </button>
          }
          header={t("agents.newAgent.selectDocumentsFromLibrary")}
          isOpen={isLibraryOpen}
          setIsOpen={setIsLibraryOpen}
          children={
            <LibraryDialogContent
              selectedItems={formData.knowledgeBase}
              handleConfirm={handleSelect}
              setIsLibraryOpen={setIsLibraryOpen}
              rootFolderName={Library.DOCUMENTS}
            />
          }
        />
        <div className="mt-4">
          {formData.knowledgeBase.length > 0 ? (
            <div className="grid max-h-[40vh] gap-4 overflow-auto">
              {formData.knowledgeBase.map((item) => (
                <div
                  key={item.id}
                  className="flex h-20 items-center justify-between rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900"
                >
                  <div className="flex items-center space-x-3">
                    {item.type === "Folder" ? (
                      <FaFolder className="h-5 w-5 text-yellow-500 dark:text-yellow-400" />
                    ) : (
                      getFileIcon(item.name)
                    )}
                    <div>
                      <div className="font-medium text-gray-900 dark:text-gray-100">
                        {item.name}
                      </div>
                      <div className="text-sm text-gray-500 dark:text-gray-400">
                        {formatFileSize(item.document_metadata.file_size ?? 0)}
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        knowledgeBase: prev.knowledgeBase.filter(
                          (file) => file.id !== item.id
                        ),
                      }));
                    }}
                    className="text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-300"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center py-10 text-center">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {t("agents.newAgent.noFilesAdded")}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;
